import React, { ReactNode } from "react";
import cn from "classnames";
import styled from "styled-components";

interface HomeBgItemProps {
  children: ReactNode;
  type?: string;
  color?: string;
  noItem?: boolean;
}

const HomeBgItem = (props: HomeBgItemProps) => {
  return (
    <StyledBgItem className={cn({ renewal: props.type === "renewal" }, { white: props.color === "white" }, { noItem: props.noItem })}>
      {props.children}
    </StyledBgItem>
  );
};

const StyledBgItem = styled.div`
  padding: 15px;
  border-radius: 4px;
  background-color: #f4f4f4;
  a {
    ${({ theme }) => theme.flexBox.flexMixin()};
    .title {
      ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center")};
      font-size: 16px;
      font-weight: 700;
      & + .text {
        margin-top: 20px;
      }
      .brand_name {
        color: ${({ theme }) => theme.color.secondary};
        display: inline-block;
        padding: 2px;
        margin-right: 8px;
        background-color: rgb(219, 225, 244);
        font-size: 12px;
        font-weight: normal;
        line-height: 1;
        text-align: center;
      }
    }
    .cate-info {
      ${({ theme }) => theme.flexBox.flexMixin()}
      .title {
        font-size: 16px;
        font-weight: 700;
      }
      & + .text {
        margin-top: 20px;
      }
    }
    .text {
      color: ${({ theme }) => theme.color.secondary};
      ${({ theme }) => theme.textOverflow.multiLine(2)}
      line-height: 20px;
      & + .date {
        margin-top: 10px;
      }
      .copy-com {
        display: inline-block;
        padding: 2px;
        margin-right: 8px;
        background-color: #dbe1f4;
        font-size: 12px;
        line-height: 1;
        text-align: center;
      }
    }
    .date {
      color: ${({ theme }) => theme.color.secondary};
      font-family: "Poppins";
      font-weight: 400;
    }
    .sub-info {
      ${({ theme }) => theme.flexBox.flexMixin()}
      margin-top: 10px;
      .shop-type {
        display: inline-block;
        color: ${({ theme }) => theme.color.secondary};
        & + .shop-name {
          margin-left: 11px;
          padding-left: 11px;
        }
      }
      .shop-name {
        position: relative;
        display: inline-block;
        margin-right: 15px;
        color: #000;
        font-weight: 500;
        &::before {
          content: "";
          position: absolute;
          top: 1px;
          left: -1px;
          display: block;
          width: 2px;
          height: 16px;
          background: ${({ theme }) => theme.color.lineSecondary};
        }
        > svg {
          position: relative;
          top: -1px;
          margin-left: 3px;
        }
      }
      .date {
        display: inline-block;
        & + .chat {
          margin-left: 16px;
        }
      }
      .chat {
        padding-left: 4px;
        flex-shrink: 0;
        color: #747474;
        font-family: "Poppins";
        font-weight: 400;
        &.new {
          color: ${({ theme }) => theme.color.subMain};
        }
        > svg {
          position: relative;
          left: -4px;
          top: -1px;
        }
      }
    }
    > div {
      width: 100%;
    }
    & + button {
      margin-top: 10px;
    }
  }
  .status {
    flex-basis: 35%;
    text-align: right;
    > p {
      color: ${({ theme }) => theme.color.secondary};
      font-size: 17px;
      font-weight: 700;
      &.active {
        color: ${({ theme }) => theme.color.markAs};
      }
      &.warning {
        color: ${({ theme }) => theme.color.warning};
      }
    }
  }
  .noData {
    padding: 35px 0;
    color: #000;
    text-align: center;
  }
  & + & {
    margin-top: 8px;
  }
  & + button {
    margin-top: 30px;
  }
  &.white {
    background-color: #fff;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  }
  &.noItem {
    width: 100% !important;
  }
  &.renewal {
    width: 136px;
    height: 248px;
    padding: 24px 15px 16px;
    a {
      ${({ theme }) => theme.flexBox.flexMixin("column", "stretch", "stretch")};
      width: 100%;
      min-width: 106px;
      height: 100%;
      flex: 1 0 auto;
      .renewal-box {
        ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")};
        height: 100%;
        .title {
          font-size: 16px;
          ${({ theme }) => theme.textOverflow.singleLine()}
          & + .text {
            margin-top: 14px;
          }
        }
        .text {
          ${({ theme }) => theme.textOverflow.multiLine(4)}
          .copy-com {
            display: block;
            margin-right: 0;
            margin-bottom: 4px;
            word-break: keep-all;
          }
        }
        .sub-info {
          ${({ theme }) => theme.flexBox.flexMixin("column", "space-between", "stretch")};
          padding-top: 8px;
          margin-top: 8px;
          border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
          font-size: 12px;
          .shop-type {
            color: ${({ theme }) => theme.color.tertiary};
            line-height: 20px;
            & + .shop-name {
              margin-left: 0;
              padding-left: 0;
            }
          }
          .shop-name {
            position: relative;
            display: inline-block;
            height: 32px;
            margin-bottom: 4px;
            color: #000;
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            ${({ theme }) => theme.textOverflow.multiLine(2)}
            &::before {
              display: none;
            }
          }
          .date {
            color: ${({ theme }) => theme.color.tertiary};
          }
        }
      }
    }
  }
`;

export default HomeBgItem;
